var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordCloseLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.02588 8.37195C3.92334 9.89303 4.78413 10.7681 5.91378 11.5929M5.91378 11.5929C7.13043 12.4789 8.60118 12.8701 10.0267 13.1822M5.91378 11.5929L4.52606 13.3954M21.0281 8.37195C20.0113 10.1672 19.2657 10.7133 18.136 11.538M18.136 11.538C16.9194 12.4241 15.4528 12.8701 14.0272 13.1822M18.136 11.538L19.5279 13.3954M10.0267 13.1822L9.52667 15.6281M10.0267 13.1822C11.3481 13.4656 12.7058 13.4656 14.0272 13.1822M14.0272 13.1822L14.5273 15.6281",
    stroke: "#656567",
    strokeWidth: 1.68171,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordCloseLight);
export default __webpack_public_path__ + "static/media/Password Close Light.ab2747b12b60348f9f842a8dfdd22c1e.svg";
export { ForwardRef as ReactComponent };